module.exports = __webpack_public_path__ + "img/group_logo.e326cd77.png";